import useUserInput from './userInputHook'

const useValueInput = <T>(defaultValue: T) => {
  return useUserInput(defaultValue, (v, sv) => sv(v))
}

export default useValueInput
